import React from 'react';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import ErrorBlock from './ErrorBlock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip';
import { TOOLTIPS, TooltipKey } from '../../mockdata/tooltips';

interface Props {
  name: string;
  label?: string;
  tooltipKey?: TooltipKey;
  tooltip?: string;
  clarification?: string;
  required?: boolean;
  error?: { message: string } |FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
  children: React.ReactNode;
  fullWidth?: boolean; // if true → ignore label and use 1-column mode
  noErrorBlock?: boolean; // if true → do not show error block
  inputColumnClassName?: string;
}

const FormField: React.FC<Props> = ({ label, clarification, required, error, children, fullWidth = false, noErrorBlock = false, tooltip, tooltipKey, name, inputColumnClassName }) => {
  const tooltipHtml = tooltipKey ? TOOLTIPS[tooltipKey] : tooltip;

  return (
    <div className="row mb-4">
      {!fullWidth ? (
        <>
          {/* LABEL COLUMN */}
          <div className="col-12 col-md-2 d-flex flex-column justify-content-start pt-2">
            <div className="d-flex justify-content-between">
              <div className="d-flex justify-content-start">
                <div className="label">
                  {label}
                  {required && <span className="form-required">*</span>}
                </div>
              </div>
              <div>
                {tooltipHtml && (
                  <div data-tooltip-html={tooltipHtml} data-tooltip-id={`${name}-tooltip`} data-tooltip-place="right">
                    <FontAwesomeIcon icon={faCircleQuestion as IconProp} className="text-xl color-blue" />
                    <Tooltip id={`${name}-tooltip`} className="form-tooltip" />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* INPUT COLUMN */}
          <div className={`col-12 col-md-10 ${inputColumnClassName || ''}`}>
            {children}
            {!noErrorBlock && <ErrorBlock error={error} clarification={clarification} />}
          </div>
        </>
      ) : (
        <>
          {/* FULL-WIDTH INPUT */}
          <div className="col-12">{children}</div>

          {/* Centered ERROR below */}
          <div className="col-12 d-flex justify-content-center">{!noErrorBlock && <ErrorBlock error={error} clarification={clarification} />}</div>
        </>
      )}
    </div>
  );
};

export default FormField;
